import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import withTranslations from "~/components/_hocs/withTranslations"

const OtherPersonalInfoAnchor = styled.a`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  ${"" /* text-indent: ${props => props.isMobile ? '' : '11px'}; */}
`
const TextWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  max-width: 364px;
  width: 100%;
`

@inject((all) => ({
  isMobile: all.store.ui.isMobile,
  isNYSLicense: all.store.trafficLookup.isNYSLicense,
  toggleSearchUsingOtherInfo:
    all.store.trafficLookup.toggleSearchUsingOtherInfo,
}))
@observer
class OtherPersonalInfo extends Component {
  handleClick = () => {
    this.props.toggleSearchUsingOtherInfo()
  }

  render() {
    return (
      <TextWrapper>
        <OtherPersonalInfoAnchor
          onClick={this.handleClick}
          isMobile={this.props.isMobile}
        >
          {this.props.translate("otherPersonalInfo")}
        </OtherPersonalInfoAnchor>
      </TextWrapper>
    )
  }
}

export default withTranslations(OtherPersonalInfo, "traffic")
